import { useTranslation } from 'react-i18next';
import { useCurrentUser } from 'src/hooks';
import { type OrgTabOptionsValue, OrgTabOptionsValueEnum } from 'src/types';

type Props = {
  currentTab: OrgTabOptionsValue;
  handleTabChange: (tab: OrgTabOptionsValue) => void;
};

export const Tabs = ({ currentTab, handleTabChange }: Props) => {
  const { t } = useTranslation();
  const { user } = useCurrentUser();
  const isAdmin = user?.subscription.role === 'admin';
  const tabs = Object.values(OrgTabOptionsValueEnum).filter(
    (tab) => tab !== OrgTabOptionsValueEnum.analytics || isAdmin,
  );

  return (
    <div className='absolute bottom-0 flex w-full max-w-[460px] flex-col items-center justify-center'>
      <ul className='flex w-full min-w-full max-w-full flex-row items-center justify-center gap-0'>
        {tabs.map((tab) => {
          return (
            <li
              key={tab}
              onClick={() => handleTabChange(tab as OrgTabOptionsValue)}
              className={`flex h-12 w-fit max-w-full cursor-pointer items-center justify-center px-2 py-4 text-center font-secondary text-base font-bold leading-5 transition-all sm:px-4 md:px-6 ${
                currentTab === tab
                  ? 'bg-offWhite text-primary-dark'
                  : 'bg-primary-off text-offWhite'
              }`}
            >
              {t(`org_settings.tabs.${tab}`)}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
